/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: ts0SJTqXQoqH

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import AccordionSectionHeader from "../../AccordionSectionHeader"; // plasmic-import: kAWnPiDkalqP/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicAccordionSection.module.css"; // plasmic-import: ts0SJTqXQoqH/css

createPlasmicElementProxy;

export type PlasmicAccordionSection__VariantMembers = {
  active: "active";
};
export type PlasmicAccordionSection__VariantsArgs = {
  active?: SingleBooleanChoiceArg<"active">;
};
type VariantPropType = keyof PlasmicAccordionSection__VariantsArgs;
export const PlasmicAccordionSection__VariantProps = new Array<VariantPropType>(
  "active"
);

export type PlasmicAccordionSection__ArgsType = {
  header?: React.ReactNode;
  body?: React.ReactNode;
};
type ArgPropType = keyof PlasmicAccordionSection__ArgsType;
export const PlasmicAccordionSection__ArgProps = new Array<ArgPropType>(
  "header",
  "body"
);

export type PlasmicAccordionSection__OverridesType = {
  accordionSection?: Flex__<"div">;
  transitionWrapper?: Flex__<"div">;
};

export interface DefaultAccordionSectionProps {
  header?: React.ReactNode;
  body?: React.ReactNode;
  active?: SingleBooleanChoiceArg<"active">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicAccordionSection__RenderFunc(props: {
  variants: PlasmicAccordionSection__VariantsArgs;
  args: PlasmicAccordionSection__ArgsType;
  overrides: PlasmicAccordionSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "active",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.active
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"accordionSection"}
      data-plasmic-override={overrides.accordionSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.accordionSection,
        { [sty.accordionSectionactive]: hasVariant($state, "active", "active") }
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <AccordionSectionHeader
            active={true}
            className={classNames(
              "__wab_instance",
              sty.accordionSectionHeader__tsVZ
            )}
            product={"myEvaluations"}
            title={
              "System integrating evaluations, milestones, EPAs, quizzes, schedules and more."
            }
          />
        ),

        value: args.header
      })}
      <div
        data-plasmic-name={"transitionWrapper"}
        data-plasmic-override={overrides.transitionWrapper}
        className={classNames(projectcss.all, sty.transitionWrapper, {
          [sty.transitionWrapperactive]: hasVariant($state, "active", "active")
        })}
      >
        {(hasVariant($state, "active", "active") ? true : false)
          ? renderPlasmicSlot({
              defaultContents: (
                <div className={classNames(projectcss.all, sty.freeBox__tzB2R)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__tiCnl)}
                  />

                  <div
                    className={classNames(projectcss.all, sty.freeBox__lmruD)}
                  >
                    <h4
                      className={classNames(
                        projectcss.all,
                        projectcss.h4,
                        projectcss.__wab_text,
                        sty.h4___9XokW
                      )}
                    >
                      {"Experience the Future of Medical Education Management"}
                    </h4>
                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p___3Lt
                      )}
                    >
                      {
                        "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes."
                      }
                    </p>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__krDtu)}
                  >
                    <h6
                      className={classNames(
                        projectcss.all,
                        projectcss.h6,
                        projectcss.__wab_text,
                        sty.h6__njRjY
                      )}
                    >
                      {"Key Features"}
                    </h6>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__lQEr)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__k3Ge9
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <ul
                              className={classNames(
                                projectcss.all,
                                projectcss.ul,
                                sty.ul___9Uz7F
                              )}
                            >
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__j8PBq
                                )}
                              >
                                {"Evaluations, Milestones & EPAs"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__ymU1T
                                )}
                              >
                                {
                                  "Performance Improvement Plans & Clinical Learning Contracts"
                                }
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__mRkj9
                                )}
                              >
                                {"Scheduling and Compliance"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__wMuAr
                                )}
                              >
                                {"Educational Compliance"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__nd798
                                )}
                              >
                                {"ACGME Compliance Tracking"}
                              </li>
                            </ul>
                          }
                          <React.Fragment>{""}</React.Fragment>
                        </React.Fragment>
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__hrwvh
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>{""}</React.Fragment>
                          {
                            <ul
                              className={classNames(
                                projectcss.all,
                                projectcss.ul,
                                sty.ul__pfqnY
                              )}
                            >
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__az1XI
                                )}
                              >
                                {"Curriculum Management"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__vrVkj
                                )}
                              >
                                {"MyQuiz & Learning Assignments"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__t10Di
                                )}
                              >
                                {"Procedure & Patient Logging"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__nWt4
                                )}
                              >
                                {"Return Demonstrations"}
                              </li>
                              <li
                                className={classNames(
                                  projectcss.all,
                                  projectcss.li,
                                  projectcss.__wab_text,
                                  sty.li__kgsHu
                                )}
                              >
                                {"Administrative Tools"}
                              </li>
                            </ul>
                          }
                          <React.Fragment>{""}</React.Fragment>
                        </React.Fragment>
                      </div>
                    </div>
                  </div>
                </div>
              ),
              value: args.body
            })
          : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  accordionSection: ["accordionSection", "transitionWrapper"],
  transitionWrapper: ["transitionWrapper"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  accordionSection: "div";
  transitionWrapper: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicAccordionSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicAccordionSection__VariantsArgs;
    args?: PlasmicAccordionSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicAccordionSection__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicAccordionSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAccordionSection__ArgProps,
          internalVariantPropNames: PlasmicAccordionSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAccordionSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "accordionSection") {
    func.displayName = "PlasmicAccordionSection";
  } else {
    func.displayName = `PlasmicAccordionSection.${nodeName}`;
  }
  return func;
}

export const PlasmicAccordionSection = Object.assign(
  // Top-level PlasmicAccordionSection renders the root element
  makeNodeComponent("accordionSection"),
  {
    // Helper components rendering sub-elements
    transitionWrapper: makeNodeComponent("transitionWrapper"),

    // Metadata about props expected for PlasmicAccordionSection
    internalVariantProps: PlasmicAccordionSection__VariantProps,
    internalArgProps: PlasmicAccordionSection__ArgProps
  }
);

export default PlasmicAccordionSection;
/* prettier-ignore-end */
